module.exports = __webpack_public_path__ + "img/banner04.0eca20cf.jpg";